import React, { useState } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import "./AwardsCarousel.css";

const awardsData = [
  {
    title: "IT Excellence Award (2024)",
    mainImage: "https://th.bing.com/th/id/OIP.ynE73Mfg-9tnqOPX8uYEnAHaD4?rs=1&pid=ImgDetMain",
    hoverIcon: "https://c8.alamy.com/comp/W9E6XB/best-winner-award-icon-simple-illustration-of-best-winner-award-vector-icon-for-web-design-isolated-on-white-background-W9E6XB.jpg",
    description: "Recognized for delivering innovative IT solutions in software development and digital engineering.",
  },
  {
    title: "Non-IT Workforce Recognition",
    mainImage: "https://www.discoverdatascience.org/wp-content/uploads/2022/06/artificial-intelligence-engineer.jpg",
    hoverIcon: "https://st5.depositphotos.com/5532432/65634/v/450/depositphotos_656349538-stock-illustration-award-trophy-icon-vector-symbol.jpg",
    description: "Acknowledged for providing skilled professionals across operations, support, and non-IT services.",
  },
  {
    title: "Emerging Technology Leadership",
    mainImage: "https://www.ai-engineering.technology/wp-content/uploads/2020/10/18298-scaled.jpg",
    hoverIcon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSWLSydBG_snqCY46ZuS7DyO1TyGCfBL_ixnw&s",
    description: "Awarded for contributions in Cloud, AI/ML, and Digital Transformation initiatives.",
  },
  {
    title: "Talent Development Recognition",
    mainImage: "https://as1.ftcdn.net/v2/jpg/05/74/20/14/1000_F_574201479_OgHXfkEb0vVR6omSJmxWnurgcTVRo02M.jpg",
    hoverIcon: "https://as1.ftcdn.net/jpg/01/61/99/40/1000_F_161994040_ld8vGuEunwxpFv8tZuBhQDF9g0nn4wBg.jpg",
    description: "Honored for training and upskilling programs across IT and Non-IT job roles.",
  },
  {
    title: "Sustainable Business Practices",
    mainImage: "https://th.bing.com/th/id/OIP.k2gdjvlCvpWvuF6lRzh1-QHaE8?w=780&h=520&rs=1&pid=ImgDetMain",
    hoverIcon: "https://as1.ftcdn.net/jpg/01/93/86/54/1000_F_193865461_hRB55fSKdZc857liANWDzufNEOuWvp4T.jpg",
    description: "Recognized for eco-friendly operations and socially responsible hiring practices.",
  },
];


const AwardsCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const visibleCards = 3.5;

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + awardsData.length) % awardsData.length);
  };

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % awardsData.length);
  };

  const getVisibleAwards = () => {
    const result = [];
    for (let i = 0; i < visibleCards; i++) {
      result.push(awardsData[(currentIndex + i) % awardsData.length]);
    }
    return result;
  };

  return (
    <div className="awards-section">
      <div className="awards-header">
        <h2>
          <span className="highlight">Awards</span> and Recognitions
        </h2>
        <div className="carousel-controls">
          <button className="arrow" onClick={prevSlide}><FaArrowLeft /></button>
          <button className="arrow" onClick={nextSlide}><FaArrowRight /></button>
        </div>
      </div>

      <div className="carousel-wrapper">
        <div className="carousel">
          {getVisibleAwards().map((award, index) => (
            <div className="award-card" key={index}>
              <div
                className="card-background"
                style={{ backgroundImage: `url(${award.mainImage})` }}
              >
                <div className="card-overlay">
                  <h3 className="title-text">{award.title}</h3>
                  <div className="hover-content">
                    <img src={award.hoverIcon} alt="Hover Icon" className="hover-icon" />
                    <p className="description">{award.description}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AwardsCarousel;
